import Vue from 'vue'
export default {
    state: {
        settings: {},
        addedAddress: {},
        addresses: [],
        countries: [],
        recalculating: false,
        formValidationData: null
    },
    getters: {
        getSummary(state) {
            return state.settings
        },
        getAddresses(state) {
            return state.addresses
        },
        getAddedAddress(state) {
            return state.addedAddress
        },
        getCountries(state) {
            return state.countries
        },
        getRecalculating(state) {
            return state.recalculating
        }
    },
    mutations: {
        SET_SUMMARY(state, payload) {
            let passedPayments = Vue.prototype.$appState.payments;
            if (!passedPayments || !passedPayments.length) {
                return state.settings = payload
            }
            let originalPayments = payload.payments.methods;
            let updatedPayments = {};
            passedPayments.forEach(payment => {
                if (originalPayments.hasOwnProperty(payment)) {
                    updatedPayments[payment] = originalPayments[payment];
                }
            });
            payload.payments.methods = updatedPayments;
            state.settings = payload
        },
        SET_ADDED_ADDRESS(state, payload) {
            state.addedAddress = payload
        },
        SET_ADDRESSES(state, payload) {
            state.addresses = payload
        },
        SET_COUNTRIES(state, payload) {
            state.countries = payload
        },
        SET_RECALCULATING(state, payload) {
            state.recalculating = payload
        },
        SET_FORM_VALIDATION_DATA(state, data) {
            state.formValidationData = data
        }
    },
    actions: {
        validateFormData({ commit }, data) {
            commit('SET_FORM_VALIDATION_DATA', data);
        },
        summaryHandler({ commit }) {
            if (window.salla.config.isGuest()) {
                return;
            }
            return new Promise((resolve, reject) => {
                window.salla.api.request(window.mini.checkoutURL)
                    .then((res) => {
                        commit('SET_SUMMARY', res.data)
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    })
            })
        },
        addressesHandler({ commit }) {
            if (window.salla.config.isGuest()) {
                return;
            }
            return new Promise((resolve, reject) => {
                window.salla.api.request(`${window.mini.checkoutURL}/address/national`)
                    .then((res) => {
                        commit('SET_ADDRESSES', res.data)
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    })
            })
        },
        countriesHandler({ commit }) {
            if (window.salla.config.isGuest()) {
                return;
            }
            return new Promise((resolve, reject) => {
                window.salla.api.request(`${window.mini.apiUrl}/shipping/countries`)
                    .then((res) => {
                        commit('SET_COUNTRIES', res.data)
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    })
            })
        },
        recalculateHandler({ commit }, method) {
            commit('SET_RECALCULATING', true)
            let queryString = method ? `?payment_method=${method}` : "";
            return new Promise((resolve, reject) => {
                window.salla.api.request(`${window.mini.checkoutURL}/payments/recalculate${queryString}`)
                    .then((res) => {
                        commit('SET_SUMMARY', res.data);
                        commit('SET_RECALCULATING', false)
                        resolve(res);
                    }).catch((err) => {
                        reject(err);
                    })
            })
        }
    },
}
